var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found"},[_c('div',{staticClass:"text border-r"},[_vm._v("404")]),_c('div',{staticClass:"text"},[_vm._v("NOT FOUND")])])}]

export { render, staticRenderFns }